// import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, ElementRef, HostListener } from '@angular/core';
// import { I18nService } from '../i18n/i18n.service';

// @Component({
//   selector: 'app-new-language-selector',
//   templateUrl: './language-selector.component.html',
//   styleUrls: ['./language-selector.component.scss'],
// })
// export class LanguageSelectorComponent implements OnInit, AfterViewInit {
//   @Input() showLabel = true;

//   selectedLanguage: string = '';
//   isOpen: boolean = false;

//   languageMap: { [key: string]: string } = {
//     EN: 'EN (English)',
//     FR: 'FR (French)',
//     DE: 'DE (German)',
//     IT: 'IT (Italian)',
//     ES: 'ES (Spanish)',
//     PT: 'PT (Portuguese)',
//     RU: 'RU (Russian)',
//     ZH: 'ZH (Simplified Chinese)',
//     AR: 'AR (Arabic)',
//     HI: 'HI (Hindi)',
//     JA: 'JA (Japanese)',
//   };

//   displayLanguages: any[] = [];

//   constructor(private i18nService: I18nService, private cdr: ChangeDetectorRef, private elementRef: ElementRef) { }

//   @HostListener('document:click', ['$event'])
//   onDocumentClick(event: Event) {
//     if (!this.elementRef.nativeElement.contains(event.target)) {
//       this.isOpen = false;
//     }
//   }

//   private normalizeLanguageCode(languageCode: string): string {
//     if (!languageCode) return '';
//     return languageCode.toLowerCase();
//   }

//   ngOnInit() {
//     this.updateDisplayLanguages();

//     const storedLanguage = localStorage.getItem('language');
//     if (storedLanguage) {
//       this.selectedLanguage = this.normalizeLanguageCode(storedLanguage);
//     } else {
//       this.selectedLanguage = 'en';
//     }
//   }

//   ngAfterViewInit() {
//     setTimeout(() => {
//       const storedLanguage = localStorage.getItem('language');
//       if (storedLanguage) {
//         this.selectedLanguage = this.normalizeLanguageCode(storedLanguage);
//         this.cdr.detectChanges();
//       } else if (this.i18nService.language) {
//         this.selectedLanguage = this.normalizeLanguageCode(this.i18nService.language);
//         this.cdr.detectChanges();
//       }
//     }, 200);
//   }

//   private updateDisplayLanguages() {
//     if (this.i18nService.supportedLanguages) {
//       this.displayLanguages = this.i18nService.supportedLanguages
//         .filter((code) => this.languageMap[code.toUpperCase()]) // Only include languages that exist in our map
//         .map((code) => ({
//           code: code.toLowerCase(),
//           displayName: this.languageMap[code.toUpperCase()] || code,
//         }));
//     } else {
//       this.displayLanguages = [];
//     }
//   }

//   toggleDropdown() {
//     this.isOpen = !this.isOpen;
//   }

//   getSelectedDisplayName(): string {
//     const selected = this.displayLanguages.find((lang) => lang.code === this.selectedLanguage);
//     return selected ? selected.displayName : '';
//   }

//   selectLanguage(code: string) {
//     const language = this.normalizeLanguageCode(code);
//     const uppercaseLanguage = language.toUpperCase();

//     try {
//       localStorage.setItem('language', language);
//       this.selectedLanguage = language;
//       this.isOpen = false;
//       this.i18nService.language = uppercaseLanguage;
//       window.location.reload();
//     } catch (error) {
//       console.error('Error setting language:', error);
//     }
//   }
// }

import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
  Inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { I18nService } from '../i18n/i18n.service';

@Component({
  selector: 'app-new-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit, AfterViewInit {
  @Input() showLabel = true;

  selectedLanguage: string = '';
  isOpen: boolean = false;

  languageMap: { [key: string]: string } = {
    EN: 'EN (English)',
    FR: 'FR (French)',
    DE: 'DE (German)',
    IT: 'IT (Italian)',
    ES: 'ES (Spanish)',
    PT: 'PT (Portuguese)',
    RU: 'RU (Russian)',
    ZH: 'ZH (Simplified Chinese)',
    AR: 'AR (Arabic)',
    HI: 'HI (Hindi)',
    JA: 'JA (Japanese)',
  };

  displayLanguages: any[] = [];

  constructor(
    private i18nService: I18nService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  private normalizeLanguageCode(languageCode: string): string {
    if (!languageCode) return '';
    return languageCode.toLowerCase();
  }

  /**
   * Helper to set document direction (ltr/rtl) and lang attribute dynamically
   */
  private setDocumentDirection(lang: string) {
    const direction = lang.toLowerCase() === 'ar' ? 'rtl' : 'ltr';
    this.document.documentElement.setAttribute('dir', direction);
    this.document.documentElement.setAttribute('lang', lang.toLowerCase());
  }

  ngOnInit() {
    this.updateDisplayLanguages();

    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      this.selectedLanguage = this.normalizeLanguageCode(storedLanguage);
    } else {
      this.selectedLanguage = 'en';
    }

    // Apply direction on load
    this.setDocumentDirection(this.selectedLanguage);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const storedLanguage = localStorage.getItem('language');
      if (storedLanguage) {
        this.selectedLanguage = this.normalizeLanguageCode(storedLanguage);
        this.setDocumentDirection(this.selectedLanguage);
        this.cdr.detectChanges();
      } else if (this.i18nService.language) {
        this.selectedLanguage = this.normalizeLanguageCode(this.i18nService.language);
        this.setDocumentDirection(this.selectedLanguage);
        this.cdr.detectChanges();
      }
    }, 200);
  }

  private updateDisplayLanguages() {
    if (this.i18nService.supportedLanguages) {
      this.displayLanguages = this.i18nService.supportedLanguages
        .filter((code) => this.languageMap[code.toUpperCase()])
        .map((code) => ({
          code: code.toLowerCase(),
          displayName: this.languageMap[code.toUpperCase()] || code,
        }));
    } else {
      this.displayLanguages = [];
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  getSelectedDisplayName(): string {
    const selected = this.displayLanguages.find((lang) => lang.code === this.selectedLanguage);
    return selected ? selected.displayName : '';
  }

  selectLanguage(code: string) {
    const language = this.normalizeLanguageCode(code);
    const uppercaseLanguage = language.toUpperCase();

    try {
      localStorage.setItem('language', language);
      this.selectedLanguage = language;
      this.isOpen = false;
      this.i18nService.language = uppercaseLanguage;

      // Set direction right before reload for immediate compliance
      this.setDocumentDirection(language);

      window.location.reload();
    } catch (error) {
      console.error('Error setting language:', error);
    }
  }
}
